import { render, staticRenderFns } from "./CombinationsSeparatedBoxes.vue?vue&type=template&id=63b24151&scoped=true"
import script from "./CombinationsSeparatedBoxes.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsSeparatedBoxes.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsSeparatedBoxes.vue?vue&type=style&index=0&id=63b24151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b24151",
  null
  
)

export default component.exports